import type { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { AuditLogRequestParams, AuditLogResponse } from '@/types/auditLog';
import RepositoryResponse from '@/types/repositoryResponse';
import ajax from '@/utils/ajax';
import defaultRepositoryError from '@/utils/defaultRepositoryError';
import logAjaxError from '@/utils/logAjaxError';

export const auditLogRepository = {
  async getAuditLog({
    host,
    params
  }: {
    host: string;
    params: AuditLogRequestParams;
  }): Promise<RepositoryResponse<AuditLogResponse>> {
    try {
      const path = '/api/auditlog/';
      const response = await ajax.get({
        url: `${host}${path}`,
        params: {
          app_label: params.appLabel,
          model: params.model,
          object_id: params.objectId
        }
      });

      return {
        data: response.data,
        isError: false
      };
    } catch (error) {
      logAjaxError(error);
      return defaultRepositoryError(error as AxiosError, 'Failed to get audit log.');
    }
  }
};

const AuditLogRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getAuditLog(
      params: AuditLogRequestParams
    ): Promise<RepositoryResponse<AuditLogResponse>> {
      return auditLogRepository.getAuditLog({ host, params });
    }
  };
};

export default AuditLogRepository;
